/** Shared Tailwind class strings for the app theme (see `globals.css` tokens). */

export const cardClass =
  "rounded-xl border border-border bg-surface px-6 py-6 shadow-card";

export const cardClassCompact =
  "rounded-xl border border-border bg-surface px-4 py-4 shadow-card";

export const listSurfaceClass =
  "divide-y divide-border rounded-xl border border-border bg-surface shadow-card";

export const btnPrimaryClass =
  "rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-primary-700 disabled:pointer-events-none disabled:opacity-50";

export const btnPrimaryClassSm =
  "rounded-lg bg-primary-600 px-3 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-primary-700 disabled:pointer-events-none disabled:opacity-50";

export const btnSecondaryClass =
  "rounded-lg border border-border bg-surface px-4 py-2 text-sm font-medium text-foreground shadow-sm transition hover:bg-muted";

export const btnSecondaryClassSm =
  "rounded-lg border border-border bg-surface px-3 py-1.5 text-sm font-medium text-foreground shadow-sm transition hover:bg-muted";

export const btnDangerOutlineClass =
  "rounded-lg border border-red-300 bg-red-50 px-4 py-2 text-sm font-medium text-red-900 shadow-sm transition hover:bg-red-100 dark:border-red-800/90 dark:bg-red-950/50 dark:text-red-200 dark:hover:bg-red-950/80";

export const labelClass = "block text-sm";

export const labelTextClass = "font-medium text-foreground";

export const inputClass =
  "mt-1 w-full rounded-lg border border-border bg-surface px-3 py-2 text-foreground shadow-sm outline-none transition placeholder:text-muted-foreground focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20";

export const inputClassNoMt =
  "w-full rounded-lg border border-border bg-surface px-3 py-2 text-foreground shadow-sm outline-none transition placeholder:text-muted-foreground focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20";
